<template>
	<div v-loading="loading" style="position: relative;flex: 1;height: 100%;overflow: hidden;">
		<div style="width: 100%;height: 100%;padding: 15px;overflow-x: hidden;overflow-y: auto;">
			<!-- 顶部查询 -->
			<div style="border: 1px solid #ccc;background: #f7f7f7;border-radius: 5px;">
				<div class="base_inquire" style="padding: 20px 30px 5px;">
					<div class="b_item">
						<el-select v-model="search_training" class="b_inp">
							<el-option :value="0" label="未参加训练"></el-option>
							<el-option :value="1" label="参加训练"></el-option>
						</el-select>
					</div>
					<div class="b_item">
						<span class="b_label">姓名：</span>
						<el-input v-model="search_name" class="b_inp" placeholder="姓名"></el-input>
					</div>
					<div class="b_item">
						<span class="b_label">账号：</span>
						<el-input v-model="search_code" class="b_inp" placeholder="账号"></el-input>
					</div>
					<div class="b_item">
						<span class="b_label">机构名称：</span>
						<el-input v-model="search_firmName" class="b_inp" placeholder="请输入机构名称"></el-input>
					</div>
					<div class="b_item">
						<span class="b_label">产品：</span>
						<el-select v-model="search_product" class="b_inp" placeholder="请选择">
							<el-option v-for="v in products" :key="v.id" :value="v.id" :label="v.name"></el-option>
						</el-select>
					</div>
					<div class="b_item">
						<span class="b_label">时间：</span>
						<el-date-picker v-model="search_time" :editable="false" :clearable="false" placeholder="时间"
							type="date" value-format="yyyy-MM-dd" @change="handleSearchTimeClick">
						</el-date-picker>
					</div>
					<el-button type="primary" @click="handleSearchClick">查询</el-button>
				</div>
			</div>
			<!-- 顶部查询 end -->

			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="name" label="姓名">
					</el-table-column>
					<el-table-column prop="code" label="账号">
					</el-table-column>
					<el-table-column prop="phone" label="手机号">
					</el-table-column>
					<el-table-column prop="firmName" label="所属机构">
					</el-table-column>
					<el-table-column prop="productName" label="产品">
					</el-table-column>
					<el-table-column prop="rNum" label="剩余次数">
					</el-table-column>
					<el-table-column prop="recentTime" label="最近训练时间">
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->

			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination layout="total, prev, pager, next, jumper" next-text="下一页" :total="total"
						:current-page="currentPage" @current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
	</div>
</template>

<script>
	import Api from '../../../../api/index.js';
	import {
		mapState
	} from 'vuex';
	import BaseMethods from '../../../../assets/js/base.js';

	export default {
		mounted() {
			this.products = [{
				id: null,
				name: '全部'
			}, ...this.allProduct];
			this.getList();
		},
		beforeDestroy() {
			this.queryInterval && clearTimeout(this.queryInterval);
		},
		data() {
			return {
				loading: false,

				products: [],

				search_training: 0,
				search_name: '',
				search_code: '',
				search_firmName: '',
				search_product: null,
				search_time: BaseMethods.getTime(new Date().getTime()),

				currentPage: 1,
				total: 0,
				tableData: [],
			}
		},
		computed: {
			...mapState([
				'authInfo',
				'allProduct'
			])
		},
		methods: {
			/******************** @Events *************************/
			// 切换查询时间
			handleSearchTimeClick() {
				if (this.search_time) {
					var search_time = new Date(this.search_time).getTime(),
						nowTime = new Date().getTime();
					if (search_time > nowTime) {
						this.search_time = BaseMethods.getTime(new Date().getTime());
						this.$message({
							message: '选择时间不能超过当前时间！！！',
							type: 'warning'
						});
					}
				}
			},
			// 点击查询
			handleSearchClick() {
				this.getList();
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},

			/******************** @Function *************************/
			// 获取列表数据
			getList() {
				const that = this;
				that.loading = true;
				var requestData = {
					"code": that.search_code,
					"existTrain": that.search_training,
					"limit": 10,
					"loginerEnterpriseId": that.authInfo.uenterpriseId,
					"loginerId": that.authInfo.uid,
					"pageNum": that.currentPage,
					"queryEnterpriseName": that.search_firmName,
					"time": that.search_time,
					"ucategory": that.authInfo.ucategory,
					"username": that.search_name,
					"versionFlag": that.search_product
				};
				Api.findUserCountTrainingMonitoring(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						var data = [];
						that.total = res.data.data.totalItems;
						res.data.data.data.forEach((v) => {
							data.push({
								name: v.username || '',
								code: v.userCode || '',
								phone: v.phone || '',
								firmId: v.enterpriseId || '',
								firmName: v.enterpriseName || '',
								productId: v.versionFlag || '',
								productName: '',
								rNum: v.rcTime || '',
								recentTime: v.lateTime ? BaseMethods.formatTime(v.lateTime) : ''
							});
						});
						that.tableData = data;
						that.mapProductIdtoName();
					} else {
						// that.$message.error(res.data.message);
						// that.$message.error('暂无数据');
						that.tableData = [];
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 把产品id转为名称
			mapProductIdtoName() {
				var arr = [...this.tableData];
				arr.forEach((v) => {
					for (var i = 0; i < this.products.length; i++) {
						v.productId == this.products[i].id && (v.productName = this.products[i].name);
					}
				});
				this.tableData = arr;
			}
		},
		watch: {
			search_num(newVal) {
				if (newVal) {
					this.positiveReg.test(newVal) || (this.search_num = this.search_num.slice(0, this.search_num.length -
						1));
				}
			}
		}
	}
</script>

<style scoped>
</style>